import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';
import white from 'sushiweb/tokens/color/white';
import OnClickOutside from 'sushiweb/HOC/OnClickOutside';

export const StatusDropdownContainer = styled(OnClickOutside)`
  position: relative;
  width: 100%;
  height: 49px;
`;

export const CustomStatusDropdown = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: ${white};
  width: 100%;
  height: 100%;
  border: 0.1rem solid ${grey.z200};
  border-radius: 0.6rem;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  padding: 0 1.2rem;
  h6 {
    font-size: 15px;
    color: ${grey.z400};
    font-weight: 300;
  }
  p {
    width: calc(100% - 10px);
    white-space: nowrap;
    overflow: scroll;
    font-size: 20px;
    color: var(--coolgreycoolgrey-700, #596378);
    margin-bottom: 0 !important; // for removing default 1.5rem sushi Paragraph margin
  }
  p::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 0px;
  }
`;

export const StatusDropdownOptions = styled.div`
  position: absolute;
  top: 5.3rem;
  width: 100%;
  border-radius: 0.6rem;
  background: ${white};
  box-shadow: 0px 1px 8px rgb(28 28 28 / 15%);
  z-index: 10;
  overflow: hidden;
  p {
    margin-bottom: 0 !important; // required to center the content
  }
`;

StatusDropdownOptions.Groups = styled.div`
  width: 100%;
  height: max-content;
  max-height: 19rem;
  overflow-y: scroll;
`;

StatusDropdownOptions.ApplyFilter = styled.div`
  position: absolute;
  width: 100%;
  height: 5rem;
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${white};
  bottom: 0;
  box-shadow: 0px -1px 20px rgba(0, 0, 0, 0.1);
  button {
    margin-left: auto;
  }
`;

export const StatusFilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  margin-right: 20px;
  p {
    font-size: 1.6rem;
    margin-bottom: 1rem;
  }
`;

export const StatusCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 1.1rem 1.4rem;
  cursor: ${props => (!props.disabled ? 'pointer' : 'default')};
  p {
    font-size: 1.6rem;
    margin-left: 0.8rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: ${props => (!props.disabled ? grey.z700 : grey.z400)};
  }
  &:hover {
    background: ${props => (!props.disabled ? grey.z100 : 'none')};
  }
`;

export const ClearCrossWrapper = styled.div`
  margin-right: 10px;
`;
